<template>
  <section
    class="RunStatusButtonList"
    :data-status-probability="modelValue"
  >
    <BallButton
      v-for="option in options"
      :key="option.label"
      :data-testid="option.testId"
      :isSelected="modelValue === option.value"
      v-bind="{...option, isDisabled}"
      @click="handleButtonClick(option.value)"
    />

    <slot />
  </section>
</template>

<script lang="ts" setup>
import BallButton from "@/components/BallButton.vue";
import haptic from "@/lib/utils/platform/haptic";
import { ImpactStyle } from "@capacitor/haptics";
import { ref } from "vue";

const modelValue = defineModel<number | null>();

defineProps<{
  isDisabled?: boolean,
}>();

const options = ref([
  {
    testId: "inButton",
    label: "In",
    value: 1,
    variant: "full",
  },
  {
    testId: "maybeButton",
    label: "Maybe",
    value: 0.5,
    variant: "half",
  },
  {
    testId: "outButton",
    label: "Out",
    value: 0,
    variant: "none",
  },
]);

function handleButtonClick (value: number) {
  haptic(ImpactStyle.Heavy);
  modelValue.value = modelValue.value === value ? null : value;
}
</script>

<style lang="scss" scoped>
.RunStatusButtonList {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--buttonGap, 12px);
  justify-items: center;
}
</style>
